module.exports = __webpack_public_path__ + "img/600.a0438d75.svg";